import React from "react";
import { Rate, Table, Typography } from "antd";
import { startCase } from "@ts/utils";
import { ISatisfactionDriversTableWidgetData } from "@ts/common-types";
import { roundToDynamicPrecisionForRating } from "@ts/widget";

const columns = [
    {
        title: "Review ID",
        dataIndex: "review_id",
        key: "review_id",
        render: (review_id: string) => (
            <Typography.Link>{`${review_id.slice(0, 8)}...`}</Typography.Link>
        ),
    },
    {
        title: "Phrase",
        dataIndex: "phrase",
        key: "phrase",
    },
    {
        title: "Channel",
        dataIndex: "channel",
        key: "channel",
    },
    {
        title: "Sentiment",
        dataIndex: "sentiment",
        key: "sentiment",
        render: (text: string) => (
            <span
                className={
                    text === "Negative"
                        ? "text-danger"
                        : text === "Positive"
                        ? "text-success"
                        : "text-secondary"
                }
            >
                {startCase(text)}
            </span>
        ),
    },
    {
        title: "Date Published",
        dataIndex: "date_published",
        key: "date_published",
    },
    {
        title: "Rating",
        dataIndex: "rating",
        key: "rating",
        render: (stars: number) => (
            <Rate
                className="text-warning small"
                value={roundToDynamicPrecisionForRating(stars || 0)}
                allowHalf
                disabled
            />
        ),
    },
    {
        title: "About Driver",
        dataIndex: "about_driver",
        key: "about_driver",
    },
];

const SatisfactionDriversTableWidget: React.FC<ISatisfactionDriversTableWidgetData> = ({ widgetData }) => {
    return (
        <Table
            className="table-fs"
            columns={columns}
            dataSource={widgetData}
            rowKey="key"
            pagination={false}
            scroll={{ y: 400 }}
            size="small"
        />
    );
};

export default SatisfactionDriversTableWidget;